/**
 * Desktop hero image lives inside `shop-informations-atom`, which only renders
 * when a shop is hydrated. In CB2 preview the shop store is often empty, so we
 * still need a desktop-only fallback for `override_image` (mobile already uses
 * `shop-hero-image-atom` with `shop || imageSrcUrl`).
 */
export function shouldShowDesktopHeroImageFallback(options: {
  shop: unknown;
  displayImage: boolean;
  imageSrcUrl: string | null | undefined;
}): boolean {
  return !options.shop && options.displayImage && !!options.imageSrcUrl;
}
